import React from 'react';
import clsx from 'clsx';

export const ButtonType = {
  primary:
    'bg-primary-500 hover:bg-primary-hover disabled:opacity-50 w-full text-white py-2 px-4 rounded-lg border border-primary',
  secondary:
    'text-primary-500 bg-white border rounded-lg hover:bg-primary-hover  border-primary-500 hover:text-white py-2 px-4 rounded w-full',
  basic: 'disabled:opacity-50 bg-primary-500 w-full hover:bg-primary-500 text-white py-2 px-4 rounded-lg',
  danger: 'bg-danger hover:bg-red-500 text-white rounded-lg disabled:opacity-50 w-full text-white py-2 px-4 rounded-lg',
  loading: 'bg-gray-55 text-gray-55 w-full py-2 px-4 rounded-lg border-none cursor-wait'
};

export const ButtonSize = {
  sm: 'py-2 px-4 text-xs',
  lg: 'py-3 px-6 text-lg'
};

type ButtonProps = {
  children?: React.ReactNode;
  kind?: keyof typeof ButtonType;
  buttonSize?: keyof typeof ButtonSize;
};

export function Button({
  children,
  className,
  type = 'button',
  kind = 'primary',
  buttonSize,
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement> & ButtonProps) {
  return (
    <button className={clsx(className, ButtonType[kind], buttonSize && ButtonSize[buttonSize])} type={type} {...rest}>
      {children}
    </button>
  );
}
